import BillingApi from '@api/BillingApi'
import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'

export default {
  [ actionTypes.GET_PAYMENT_HISTORY ] (context, options = {}) {
    context.commit(mutationTypes.BEGIN_LOADING_PAYMENT_HISTORY)
    new BillingApi({ simulateExample: 'Payment History of an invoice (AFA)' })
      .getPaymentHistory({
        params: {
          ...context.rootGetters['groupSelector/selected'],
          ...options.params
        }
      })
      .then(paymentHistory => context.commit(mutationTypes.SET_PAYMENT_HISTORY, paymentHistory))
      .catch(_ => {
        // todo
      })
      .finally(() => {
        context.state.paymentHistoryLoading = false
      })
  },

  [ actionTypes.GET_PAYMENT_METHODS ] (context, options = {}) {
    context.commit(mutationTypes.SET_LOADING_PAYMENT_METHODS, true)
    new BillingApi({ simulateExample: 'Payment Method Search - CC' })
      .getPaymentMethods({
        params: {
          ...context.rootGetters['groupSelector/selected']
        }
      })
      .then(response => context.commit(mutationTypes.SET_PAYMENT_METHODS, response))
      .catch(_ => {
        // todo

      })
      .finally(() => {
        context.commit(mutationTypes.SET_LOADING_PAYMENT_METHODS, false)
      })
  },

  [ actionTypes.GET_USER_PAYMENT_METHODS ] (context, options = {}) {
    console.log(`GET_USER_PAYMENT_METHODS`, options);
    context.commit(mutationTypes.SET_LOADING_USER_PAYMENT_METHODS, true)
    new BillingApi({ simulateExample: 'Payment Methods Search - CC' })
      .getUserPaymentMethods({
        params: {

        }
      })
      .then(response => context.commit(mutationTypes.SET_USER_PAYMENT_METHODS, response))
      .catch(_ => {
        // todo
      })
      .finally(() => {
        context.commit(mutationTypes.SET_LOADING_USER_PAYMENT_METHODS, false)
      })
  },

  [ actionTypes.GET_INVOICES ] (context, options = {}) {
    console.log(`GET_INVOICES`, options);
    context.commit(mutationTypes.BEGIN_LOADING_INVOICES);
    console.log(`opts.params`, options.params);
    // remove pagrname if we have it
    delete options.params.parentGroupName;
    new BillingApi({ simulateExample: 'Search invoices for Internal - ALL' })
      .getInvoiceSearch({
        params: {
          ...context.rootGetters['groupSelector/selected'],
          ...options.params
        }
      })
      .then(response => {
        console.log(`GET INVOICES resp`, response);
        if (response.userMessage) {
          context.commit(
            mutationTypes.SET_INVOICES_USER_MESSAGE,
            response.userMessage
          )
        } else {
          context.commit(
            mutationTypes.SET_INVOICES,
            response
          )
        }
      }
      )
      .catch(ex => {
        console.warn('ERROR GET INVOICES', ex.message, options.params);
        // todo:  actually you know...HANDLE errors.
      })
  },

  [ actionTypes.GET_INVOICE_PAYMENT_HISTORY ] (context, options = {}) {
    let hasSelection = context.rootGetters['groupSelector/hasSelection'];
    if(hasSelection) {
      context.commit(
        mutationTypes.SET_INVOICE_PAYMENT_HISTORY,
        []
      )
      context.commit(mutationTypes.SET_INVOICE_PAYMENT_HISTORY_LOADING, true)
      new BillingApi({ simulateExample: 'Search invoices for Internal - ALL' })
        .getInvoicePaymentHistory({
          params: {
            ...context.rootGetters['groupSelector/selected'],
            ...options.params
          }
        })
        .then(response => {
          if (response.userMessage) {
            context.commit(
              mutationTypes.SET_INVOICE_PAYMENT_HISTORY_USER_MESSAGE,
              response.userMessage
            )
          } else {
            context.commit(
              mutationTypes.SET_INVOICE_PAYMENT_HISTORY,
              response
            )
          }
        }
        )
        .catch(_ => {
          // todo
        });
    }
  },

  [ actionTypes.UNBLOCK_ALL_INVOICES ] (context) {
    context.commit(mutationTypes.BEGIN_UNBLOCKING_INVOICES)

    const invoiceNumbers = context.state.invoices.map(invoice => {
      return invoice.invoiceNumber
    })

    const blockParams = {
      invoiceNumbers: invoiceNumbers,
      action: '',
      ...context.rootGetters['groupSelector/selected']
    }

    return new BillingApi()
      .putInvoiceBlockStatus({ params: blockParams, body: {} })
      .then(resp => {
        context.commit(mutationTypes.UNBLOCK_ALL_INVOICES)
      })
      .catch(_ => {
        // todo, do nothing?
      })
  },

  [actionTypes.UNBLOCK_INVOICE](context, invoice) {

    context.commit(mutationTypes.BEGIN_UNBLOCKING_INVOICES)
    return new BillingApi()
      .putInvoiceBlockStatus({
        body: {
          invoiceRequestList: [{
            invoiceNumber: invoice.invoiceNumber,
            groupCk: invoice.groupCk,
            subGroupCk: invoice.subGroupCk
          }],
          action: 'UnBlock'
        }
      })
      .then(resp => {
        context.commit(mutationTypes.TOGGLE_BLOCKED_STATE_OF_SINGLE_INVOICE)
      })
      .catch(_ => {
        // todo, do nothing?
      })
  },

  [actionTypes.BLOCK_INVOICE](context, invoice) {
    context.commit(mutationTypes.BEGIN_BLOCKING_INVOICES)
    return new BillingApi()
      .putInvoiceBlockStatus({
        body: {
          invoiceRequestList: [{
            invoiceNumber: invoice.invoiceNumber,
            groupCk: invoice.groupCk,
            subGroupCk: invoice.subGroupCk
          }],
          action: 'Block'
        }
      })
      .then(resp => {
        context.commit(mutationTypes.TOGGLE_BLOCKED_STATE_OF_SINGLE_INVOICE)
      })
      .catch(_ => {
        // todo, do nothing?
      })
  },

  [ actionTypes.BLOCK_INVOICES ] (context, selectedInvoices = []) {
    context.commit(mutationTypes.BEGIN_BLOCKING_INVOICES)

    const invoices = selectedInvoices.map(invoice => {
      return {
        invoiceNumber: invoice.invoiceNumber,
        groupCk: invoice.groupCk,
        subGroupCk: invoice.subGroupCk
      }
    })

    const body = {
      invoiceRequestList: invoices,
      action: 'Block'
    }

    return new BillingApi()
      .putInvoiceBlockStatus({ body })
      .then(resp => {
        context.commit(mutationTypes.BLOCK_INVOICES, selectedInvoices)
      })
      .catch(_ => {
        // todo, do nothing?
      })
  },

  [ actionTypes.UNBLOCK_INVOICES ] (context, selectedInvoices = []) {
    context.commit(mutationTypes.BEGIN_UNBLOCKING_INVOICES)

    const invoices = selectedInvoices.map(invoice => {
      return {
        invoiceNumber: invoice.invoiceNumber,
        groupCk: invoice.groupCk,
        subGroupCk: invoice.subGroupCk
      }
    })

    const body = {
      invoiceRequestList: invoices,
      action: 'UnBlock'
    }

    return new BillingApi()
      .putInvoiceBlockStatus({ body })
      .then(resp => {
        context.commit(mutationTypes.UNBLOCK_INVOICES, selectedInvoices)
      })
      .catch(_ => {
        // todo, do nothing?
      })
  },

  [ actionTypes.GET_CYBERSOURCE_DETAILS ] (context, { lobId, key }) {
    if (!lobId) { throw new Error(`You must provide a lobId for ${actionTypes.GET_CYBERSOURCE_DETAILS}`) }
    if (!key) { throw new Error(`You must provide a key for ${actionTypes.GET_CYBERSOURCE_DETAILS}`) }

    context.commit(mutationTypes.SET_LOADING_CYBERSOURCE_DETAILS, true)
    return new BillingApi()
      .getCybersourceDetails({
        lobId,
        key
      })
      .then(cybersourceDetails => {
        context.commit(mutationTypes.SET_CYBERSOURCE_DETAILS, cybersourceDetails)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        context.commit(mutationTypes.SET_LOADING_CYBERSOURCE_DETAILS, false)
      })
  },

  [ actionTypes.GET_AUTO_PAY_DETAILS ] (context) {
    context.state.autoPayDetailsLoading = true
    return new BillingApi()
      .getAutoPayDetails()
      .then(cybersourceDetails => {
        context.commit(mutationTypes.SET_AUTO_PAY_DETAILS, cybersourceDetails)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        context.state.autoPayDetailsLoading = false
        context.commit(mutationTypes.SET_LOADING_CYBERSOURCE_DETAILS, false)
      })
  },

  [ actionTypes.GET_CYBERSOURCE_ONETIME_PAYMENT_DETAILS ] (context, { lobId, key }) {
    context.commit(mutationTypes.SET_LOADING_CYBERSOURCE_DETAILS, true)
    return new BillingApi()
      .getCybersourceOnetimeDetails({
        lobId, key
      })
      .then(cybersourceDetails => {
        context.commit(mutationTypes.SET_CYBERSOURCE_DETAILS, cybersourceDetails)
      })
      .finally(() => {
        context.commit(mutationTypes.SET_LOADING_CYBERSOURCE_DETAILS, false)
      })
  },

  [ actionTypes.GET_PAYMENT_LOBS ] (context) {
    context.state.paymentLobsLoading = true
    return new BillingApi()
      .getPaymentLobs()
      .then(hashMap => {
        const paymentLobs = hashMap['PAYMENT_LOBS'].split(',')
        context.commit(mutationTypes.SET_PAYMENT_LOBS, paymentLobs)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        context.state.paymentLobsLoading = false
      })
  },

  [ actionTypes.GET_SINGLE_INVOICE ] (context, options = {}) {
    context.commit(mutationTypes.BEGIN_LOADING_INVOICES)
    return new BillingApi({ simulateExample: 'Invoice Details' })
      .getSingleInvoice(options)
      .then(invoiceDetails => {
        if (invoiceDetails.status === 'invoiceDetailsNotFound') {
          context.commit(mutationTypes.SET_SINGLE_INVOICE_ERROR, invoiceDetails.userMessage)
        } else {
          context.commit(mutationTypes.SET_SINGLE_INVOICE, invoiceDetails)
        }
      })
      .catch(_ => {
        // this probably won't get triggered for reasons....
      })
  },

  [ actionTypes.ENFORCE_INVOICE_PORTAL_CONTEXT ] (context, invoiceDetails) {
    let group = {
      groupId: invoiceDetails.groupId,
      groupCk: invoiceDetails.groupCk,
      groupName: invoiceDetails.groupName
    }
    let subGroup = {
      subGroupId: invoiceDetails.subGroupId,
      subGroupCk: invoiceDetails.subGroupCk,
      subGroupName: invoiceDetails.subGroupName
    }
    group.subGroups = [subGroup]
    context.commit('groupSelector/SET_GROUP', group)
    context.commit('groupSelector/SET_SUB_GROUP', subGroup)
    // context.commit('portalContext/SET_PORTAL_CONTEXT_SELECTED', true)
  },

  [ actionTypes.ENFORCE_BILLING_PORTAL_CONTEXT ] (context, value) {
    // context.commit('portalContext/SET_PORTAL_CONTEXT_SELECTED', value)
  },

  [ actionTypes.MAKE_PAYMENT ] (context, { selectedUserPaymentMethod, paymentMethodId, lineOfBusiness, totalAmount, invoicesToBePaid = [], onetime = false }) {
    context.commit(mutationTypes.SET_MAKING_PAYMENT, true)

    return new BillingApi({ simulateExample: 'Payment Transaction - Multiple Invoices   - using token' })
      .postPayment({
        body: {
          lineOfBusiness,
          totalAmount,
          paymentMethodId,
          payment: invoicesToBePaid.map(invoice => {
            return {
              // ...context.rootGetters['groupSelector/selected'],
              // placeholder to allow payments to go through with new payments code using one of the invoices group/subgroup
              // TODO - replace with actual code
              groupCk: invoice.groupCk,
              subGroupCk: invoice.subGroupCk,
              paidAmount: invoice.openAmount,
              paymentMethodId,
              lineOfBusiness,
              invoiceNumber: invoice.invoiceNumber
            }
          })
        }
      })
      .then(response => {
        if (onetime) {
          context.commit(mutationTypes.SET_ONETIME_PAYMENT_VARIABLES, {
            transactionId: response.transactionId,
            totalAmount: totalAmount,
            invoicesPaid: invoicesToBePaid
          })
        } else {
          context.commit(mutationTypes.CONFIRM_PAYMENT, {
            transactionId: response.transactionId,
            totalAmount: totalAmount,
            paymentType: selectedUserPaymentMethod.displayPaymentType,
            paymentLastFour: selectedUserPaymentMethod.displayAccountNumber,
            invoicesPaid: invoicesToBePaid
          })
        }
      })
      .finally(() => context.commit(mutationTypes.SET_MAKING_PAYMENT, false))
  },

  [ actionTypes.SETUP_RECURRING_PAYMENTS ] (context, options = {}) {
    context.commit(mutationTypes.SET_CONFIGURING_RECURRING_PAYMENTS, true)
    return new BillingApi({
      simulateExample: 'Payment Method - autopay on'
    })
      .configureRecurringPayments({
        body: options.body
      })
      .then(response => {
        context.commit(mutationTypes.SET_CONFIGURING_RECURRING_PAYMENTS, false)
      })
      .catch(_ => {
        context.commit(mutationTypes.SET_CONFIGURING_RECURRING_PAYMENTS, false)
        // todo what else?
      })
  },

  [ actionTypes.DELETE_PAYMENT_METHOD ] (context, { paymentMethodId }) {
    context.commit(mutationTypes.SET_DELETING_PAYMENT_METHOD, true)
    return new BillingApi({
      simulateExample: ''
    })
      .deletePaymentMethod({
        paymentMethodId
      })
      .then(response => {
        if (response.userMessage) { context.commit('SET_ANNOUNCEMENT', response.userMessage, { root: true }) }
        context.dispatch(actionTypes.GET_PAYMENT_METHODS)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        context.commit(mutationTypes.SET_DELETING_PAYMENT_METHOD, false)
      })
  },

  [ actionTypes.UPDATE_DEFAULT_USER_PAYMENT_METHOD ] (context, { paymentMethodId }) {
    context.commit(mutationTypes.UPDATE_DEFAULT_USER_PAYMENT_METHOD_LOADING, true)
    return new BillingApi({
      simulateExample: ''
    })
      .updateDefaultUserPaymentMethod({
        paymentMethodId
      })
      .then(response => {
        if (response.userMessage) { context.commit('SET_ANNOUNCEMENT', response.userMessage, { root: true }) }
        context.dispatch(actionTypes.GET_USER_PAYMENT_METHODS)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        context.commit(mutationTypes.UPDATE_DEFAULT_USER_PAYMENT_METHOD_LOADING, false)
      })
  },

  [ actionTypes.DELETE_USER_PAYMENT_METHOD ] (context, { paymentMethodId }) {
    context.commit(mutationTypes.SET_DELETING_USER_PAYMENT_METHOD, true)
    return new BillingApi({
      simulateExample: ''
    })
      .deleteUserPaymentMethod({
        paymentMethodId
      })
      .then(response => {
        if (response.userMessage) { context.commit('SET_ANNOUNCEMENT', response.userMessage, { root: true }) }
        context.dispatch(actionTypes.GET_USER_PAYMENT_METHODS)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        context.commit(mutationTypes.SET_DELETING_USER_PAYMENT_METHOD, false)
      })
  },

  [ actionTypes.GET_SUBGROUP_DETAILS ] (context, { groupCk, subGroupCk }) {
    console.log(`GET SUBGROUP DEATILS`, groupCk, subGroupCk);
    context.commit('CLEAR_SUBGROUP_DETAILS');
    if (!groupCk && !subGroupCk) return
    context.commit(mutationTypes.SET_SUBGROUP_DETAILS_LOADING, true)
    return new BillingApi().getSubgroupDetails({
      groupCk,
      subGroupCk
    })
      .then(response => {
        context.commit(mutationTypes.SET_SUBGROUP_DETAILS, response)
      })
      .catch(error => {
        console.log(error) // todo
      })
      .finally(() => {
        context.commit(mutationTypes.SET_SUBGROUP_DETAILS_LOADING, false)
      })
  },

  [ actionTypes.GET_CASH_ON_ACCOUNTS ] (context, options = {}) {
    context.commit(mutationTypes.SET_CASH_ON_ACCOUNTS_LOADING, true)
    return new BillingApi()
      .getSubGroupCashOnAccounts({
        params: context.rootGetters['groupSelector/selected']
      })
      .then(cashOnAccounts => {
        context.commit(mutationTypes.SET_CASH_ON_ACCOUNTS, cashOnAccounts)
      })
      .finally(() => {
        context.commit(mutationTypes.SET_CASH_ON_ACCOUNTS_LOADING, false)
      })
  },

  [ actionTypes.GET_PAYMENT_HISTORY_CONFIGURATION ] (context, options = {}) {
    context.commit(mutationTypes.SET_PAYMENT_HISTORY_CONFIGURATION_LOADING, true)
    return new BillingApi()
      .getPaymentHistoryConfiguration({
        portalContext: context.rootGetters['groupSelector/selected']
      })
      .then(response => {
        context.commit(mutationTypes.SET_PAYMENT_HISTORY_ENABLED, response.status === 'NoRecordFound')
      })
      .finally(() => {
        context.commit(mutationTypes.SET_PAYMENT_HISTORY_CONFIGURATION_LOADING, false)
      })
  }
}
